// Node Modules
var calcAge = require('./calculations/age');
var calcBaths = require('./calculations/bathrooms');
var calcBeds = require('./calculations/bedrooms');
var calcHomeType = require('./calculations/home-type');
var calcLotSize = require('./calculations/lot-size');
var calcPrice = require('./calculations/price');
var calcSchools = require('./calculations/schools');
var calcSqft = require('./calculations/sqft');
var calcStories = require('./calculations/stories');
var calcWhatsImportant  = require('./calculations/whats-important');

module.exports = {

    /////////////////////////////////////////////////////
    // Private Functions
    /////////////////////////////////////////////////////

    /*
    Calculates the scores and returns the details

    @function _calculateDetails
    @param {Object} listing
    @param {Array} params - The filters you have
    @returns {Array}
    */
    _calculateDetails: function _calculateDetails(listing, params) {
        return params.map(function mapScores(filterItem) {
            if(filterItem.name === 'price' && listing.price && filterItem.value != 'any') {
                return calcPrice(listing, filterItem.value);
            } else if(filterItem.name === 'whatsimportant' && listing.reports && Object.keys(listing.reports).length > 0 && filterItem.value != 'all') {
                return calcWhatsImportant(listing, filterItem.value);
            } else if(filterItem.name === 'schools' && listing.reports && Object.keys(listing.reports).length > 0 && filterItem.value != 'any') {
                return calcSchools(listing, filterItem.value);
            } else if(filterItem.name === 'hometype' && listing.sub_type && filterItem.value != 'either') {
                return calcHomeType(listing, filterItem.value);
            } else if(filterItem.name === 'bedrooms' && listing.beds && filterItem.value != 'any') {
                return calcBeds(listing, filterItem.value);
            } else if(filterItem.name === 'bathrooms' && listing.baths && filterItem.value != 'any') {
                return calcBaths(listing, filterItem.value);
            } else if(filterItem.name === 'age' && listing.year && filterItem.value != 'any') {
                return calcAge(listing, filterItem.value);
            } else if(filterItem.name === 'stories' && listing.floors && filterItem.value != 'either') {
                return calcStories(listing, filterItem.value);
            } else if(filterItem.name === 'sqfeet' && listing.home_size && filterItem.value != 'any') {
                return calcSqft(listing, filterItem.value);
            } else if(filterItem.name === 'lotsize' && listing.lot_size && filterItem.value != 'any') {
                return calcLotSize(listing, filterItem.value);
            } else {
                return {
                    weight: 0,
                    value: 0,
                    score: 0,
                    metThreshold: true
                };
            }
        });
    },


    /////////////////////////////////////////////////////
    // Public Functions
    /////////////////////////////////////////////////////

    /*
    Calculates a listings match score and
    returns the match score.

    @function get
    @param {Object} listing
    @param {Array} params - The filters you have
    @returns {Number}
    */
    get: function getMatchScore(listing, params) {
        var matchScore = 100;

        if(params.length > 0) {
            var totalScores = 0;
            var totalWeights = 0;

            this._calculateDetails(listing, params)
                .forEach(function forEachScore(obj) {
                    if(obj) {
                        totalScores += obj.score;
                        totalWeights += 10 * obj.weight;
                    }
                });

            matchScore = Math.round(Math.max(0, totalScores / totalWeights * 100));
        }

        return matchScore;
    },

    /*
    Returns the class the match score falls into

    @function getClass
    @param {int} matchScore
    @returns {String
    */
    getClass: function getClass(matchScore) {
        if(matchScore >= 75) {
            return 'great';
        } else if(matchScore >= 50) {
            return 'good';
        } else {
            return 'poor';
        }
    },

    /*
    Returns whether the listing passed all the thresholds

    @function meetsAllThresholds
    @param {Object} listing
    @param {Array} params - The filters you have
    @returns {Boolean}
    */
    meetsAllThresholds: function meetsAllThresholds(listing, params) {
        var passed = true;

        if(params.length > 0) {
            this._calculateDetails(listing, params)
                .forEach(function forEachScore(obj) {
                    if(!obj.metThreshold) {
                        passed = false;
                    }
                });
        }

        return passed;
    },


    /////////////////////////////////////////////////////
    // The function below this line are our calculation
    // functions. There are here just in case you
    // have a reason you need to use them indeividually.
    /////////////////////////////////////////////////////

    calcAge: calcAge,
    calcBaths: calcBaths,
    calcBeds: calcBeds,
    calcHomeType: calcHomeType,
    calcLotSize: calcLotSize,
    calcPrice: calcPrice,
    calcSchools: calcSchools,
    calcSqft: calcSqft,
    calcStories: calcStories,
    calcWhatsImportant: calcWhatsImportant
};
